import React, { useEffect, useState } from "react";
import Editor from "@monaco-editor/react";
import { Col, Row } from "react-bootstrap";
import JsonPreviewComponent from "./JsonPreviewComponent";
import _ from "lodash";
import ToolTip from "../Common/Tooltip";

export const VIEWER_THEMES = [
    'vs-dark',
    'light'
]

const JsonViewerComponent = (props) => {

    const [content, setContent] = useState('');
    const [previewContent, setPreviewContent] = useState({});
    const [editorWidth, setEditorWidth] = useState(6);

    useEffect(() => {
        setEditorWidth(props.editorWidth);
    }, [props.editorWidth]);

    useEffect(() => {
        if (!_.isEmpty(props.content)) {
            setContent(props.content);
            try {
                const contentObj = JSON.parse(props.content);
                setPreviewContent(contentObj);
            } catch (e) {
                console.log(e);
            }
        }
    }, [props.content]);

    const onChangeHandler = (newValue) => {
        if (!_.isEmpty(newValue)) {
            try {
                const contentObj = JSON.parse(newValue);
                setContent(newValue);
                if (props.previewDisplay) {
                    setPreviewContent(contentObj);
                }
            } catch (e) {
                console.log(e);
            }
        }
        if (props.onContentChange !== undefined) {
            props.onContentChange(newValue);
        }
    }

    const editorOptions = {
        minimap: {
            enabled: props.minimap || false,
        },
        wordWrap: props.wordWrap ? 'on' : 'off',
        readOnly: props.readOnly !== undefined ? props.readOnly : false,
        lineNumbers: props.hideLineNumbers ? 'off' : 'on'
    }

    return (
        <>
            <Row>
                {
                    <>
                        {
                            props.editorDisplay &&
                            <Col md={editorWidth} className="text-center ">
                                <div className={`d-flex justify-content-${props.editiorIconGroupPosition}`} style={{ fontSize: props.iconSize, gap: props.iconGap }}>
                                    {
                                        props.editorHeaderIcons && props.editorHeaderIcons.map(icon => {
                                            return (
                                                <>
                                                    {(icon.display && icon.toolTipKEy) &&
                                                        <ToolTip
                                                            toolTipKEy={icon.toolTipKEy}
                                                            toolTipValue={icon.toolTipValue}
                                                            overlayComponent={
                                                                <span className={`${icon.className}`}>
                                                                    <i onClick={icon.onClickHandler} className={`${icon.iconName}`} style={{ color: `${icon.color}` }} />
                                                                </span>
                                                            }
                                                        />
                                                    }
                                                    {(icon.display && !icon.toolTipKEy) &&
                                                        <span className={`${icon.className}`}>
                                                            <i onClick={icon.onClickHandler} className={`${icon.iconName}`} style={{ color: `${icon.color}` }} />
                                                        </span>
                                                    }
                                                </>
                                            )
                                        })
                                    }
                                </div>
                                <Editor
                                    loading={props.loadingContent}
                                    height={props.height}
                                    defaultLanguage='json'
                                    value={content}
                                    options={editorOptions}
                                    onChange={onChangeHandler}
                                    theme={props.theme && VIEWER_THEMES.includes(props.theme) ? props.theme : null}
                                />
                            </Col>
                        }
                        {
                            props.previewDisplay &&
                            <Col style={{ overflowY: "auto", overflowX: "auto" }} md={props.previewWidth}>
                                <div className={`d-flex mb-2 justify-content-${props.viewerIconGroupPosition}`} style={{ fontSize: props.iconSize, gap: props.iconGap }}>
                                    {
                                        props.viewerHeaderIcons && props.viewerHeaderIcons.map(icon => {
                                            return (
                                                <>
                                                    {(icon.display && icon.toolTipKEy) &&
                                                        <ToolTip
                                                            toolTipKEy={icon.toolTipKEy}
                                                            toolTipValue={icon.toolTipValue}
                                                            overlayComponent={
                                                                <span className={`${icon.className}`}>
                                                                    <i onClick={icon.onClickHandler} className={`${icon.iconName}`} style={{ color: `${icon.color}` }} />
                                                                </span>
                                                            }
                                                        />
                                                    }
                                                    {(icon.display && !icon.toolTipKEy) &&
                                                        <span className={`${icon.className}`}>
                                                            <i onClick={icon.onClickHandler} className={`${icon.iconName}`} style={{ color: `${icon.color}` }} />
                                                        </span>
                                                    }
                                                </>
                                            )
                                        })
                                    }
                                </div>
                                <JsonPreviewComponent
                                    height={props.height}
                                    data={previewContent}
                                />
                            </Col>
                        }
                    </>
                }
            </Row>
        </>
    )
}

export default JsonViewerComponent;